import React from 'react';
import { string, number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { CalloutCard as CalloutCardComponent } from '@thd-olt-component-react/callout_card';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function CalloutCard({
  id,
  layoutRendererPrerenderedChildIndex
}) {
  const componentPosition = layoutRendererPrerenderedChildIndex ? layoutRendererPrerenderedChildIndex + 1 : 1;

  return (
    <ErrorBoundary name="callout_card">
      <QueryProvider key={id} cacheKey="callout-card-cache">
        <CalloutCardComponent
          componentId={id}
          componentClass="CalloutCard"
          componentPosition={componentPosition}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

CalloutCard.propTypes = {
  id: string,
  layoutRendererPrerenderedChildIndex: number,
};

CalloutCard.defaultProps = {
  id: undefined,
  layoutRendererPrerenderedChildIndex: undefined,
};
